import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'elleve',
      storage,
      whitelist: ['auth', 'user', 'propostas'],
    },
    reducers
  );

  return persistedReducer;
};
